import { ShippingAddresses, BillingAddress } from "../components/AddressManager";

export default function MyAddresses() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-12 py-12 space-y-16" data-testid="my-addresses-page">
      <div>
        <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#7AC143] mb-3">Mon compte</div>
        <h1 className="text-4xl font-black tracking-tighter">Mes adresses</h1>
        <p className="text-[#4B634B] mt-3 max-w-2xl">Gérez votre adresse de facturation (unique, obligatoire) et vos adresses de livraison (multiples).</p>
      </div>
      <BillingAddress />
      <ShippingAddresses />
    </div>
  );
}
